import { Instagram, Linkedin, Facebook } from 'lucide-react';
import TrripLogo from '../../../../../assets/Trrip_logo/trrip_logo.png';

const FooterBrandInfo = () => {
  return (
    <div className="col-span-1 md:col-span-2 space-y-4 sm:space-y-6">
      <img src={TrripLogo} alt="Trrip" className="w-32 sm:w-40" />
      <p className="text-gray-600 text-xs sm:text-sm max-w-sm leading-relaxed">
        Trrip connects agents, tour operators, and travellers through a single system that ensures
        better coordination, safety, and transparency.
      </p>
      <div className="flex gap-3.5 sm:gap-4">
        <a
          href="https://www.instagram.com/trrip_live?utm_source=ig_web_button_share_sheet&igsi=ZDNlZDc0MzIxNw=="
          target="_blank"
          rel="noopener noreferrer"
          className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-gray-200 hover:bg-gray-300 text-gray-600 hover:text-[#E1306C] transition-all flex items-center justify-center cursor-pointer"
          aria-label="Instagram"
        >
          <Instagram size={18} className="sm:w-5 sm:h-5" />
        </a>
        <a
          href="https://www.linkedin.com/company/orbitra-technologies/"
          target="_blank"
          rel="noopener noreferrer"
          className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-gray-200 hover:bg-gray-300 text-gray-600 hover:text-[#0077b5] transition-all flex items-center justify-center cursor-pointer"
          aria-label="LinkedIn"
        >
          <Linkedin size={18} className="sm:w-5 sm:h-5" />
        </a>
        <a
          href="https://www.facebook.com/people/Trrip-by-Orbitra-Technologies/61578892372362/"
          target="_blank"
          rel="noopener noreferrer"
          className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-gray-200 hover:bg-gray-300 text-gray-600 hover:text-[#1877F2] transition-all flex items-center justify-center cursor-pointer"
          aria-label="Facebook"
        >
          <Facebook size={18} className="sm:w-5 sm:h-5" />
        </a>
      </div>
    </div>
  );
};

export default FooterBrandInfo;
